import { useMediaQuery,TextField } from "@mui/material"
import { BrowserRouter as Router, Switch, Route, Redirect, useRouteMatch, useParams } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { SellInvoicePage } from "./pages/SellInvoicePage";
import { ReportsPage } from "./pages/ReportsPage";
import { InvoiceStatusPage } from "./pages/InvoiceStatusPage";
import { ProtectedRoute } from "@sb1finans/components/dist/ProtectedRoute"
import { Sb1Header } from "@sb1finans/components/dist/Sb1Header"
import { Stats } from "./pages/Stats";
import OrderList from "./pages/OrderList";
import { useContext, useMemo } from "react";
import { AgreementContext } from "@sb1finans/components/dist/AgreementContext";
import LoadingContainer from "@sb1finans/components/dist/LoadingContainer";
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import SelectMenuItem from "@mui/material/MenuItem"
import { Link } from "react-router-dom";
import { default as useApiContext } from "@sb1finans/components/dist/ApiProvider";
import React from "react";
import { AccountProvider } from "./providers/AccountProvider";
import { OrderProvider } from "./providers/OrderProvider";
import { useAgreementId } from "./hooks";

export const PortalApp: React.FC = () => {
    // Fetch token from somewhere
    const betaParam = useMemo(() => new URLSearchParams(window.location.search).get("isBeta"), [])
    if (betaParam) {
        // Set token on local storage
        localStorage.setItem("isBeta", betaParam)
    }
    
    console.info("Starting portal app. Is beta: ", betaParam)
    return (
        <>
            <Router>
                <Switch>
                    <Route path="/" exact>
                        <Redirect to={`/avtale`} />
                    </Route>
                    <Route path={`/avtale`}>
                        <NewAgreementRouter />
                    </Route>
                    <Route path={`/stats`}>
                        <Stats />
                    </Route>
                </Switch>
            </Router>
        </>
    )
}

interface PathParams {
    agreementId: string
}

const NewAgreementRouter = () => {

    const { agreements, isFetching } = useContext(AgreementContext);
    const {vendorsApi} = useApiContext()
    const { url } = useRouteMatch();

    const renderContent = () => {
        const activeAgreementId = agreements && agreements[0].id
        console.info(`IS Fetching: ${isFetching} isActive: ${activeAgreementId}`)
        if (!isFetching && activeAgreementId) {
            console.log("RENDERING HOME PAGE")
            return (
                <>
                    <Route path={`${url}`} exact>
                        <Redirect to={`${url}/${activeAgreementId}`} />
                    </Route> 
                    <Route path={`${url}/:agreementId`}>
                        <AccountProvider vendorsApi={vendorsApi}>
                            <OrderProvider vendorsApi={vendorsApi}>
                                <AgreementRouter agreements={agreements}/>
                            </OrderProvider>
                        </AccountProvider>
                    </Route>
                </>
            )
        } else if (isFetching) {
            return (
                <LoadingContainer />
            )
        } else {
            return (
                <Alert severity="error">
                    Kunne ikke hente ditt kundeengasjement. Det kan skyldes at du ikke har et kundeforhold hos oss, eller en feil i våre systemer. 
                    Dersom du mener dette er feil, ta kontakt med kundesenteret vårt.
                </Alert>
            )
        }
    }

    return (
        <>
        { 
            renderContent()
        }
        </>
    )
}

interface AgreementRouterProps {
    agreements: any[]
}
const AgreementRouter: React.FC<AgreementRouterProps> = ({agreements}) => {
    const { url } = useRouteMatch();

    const {vendorsApi} = useApiContext()

    console.log("URL is ", url)

    const { agreementId } = useParams<PathParams>();
    const { agreementId: activeAgreementId } = useAgreementId()
    console.log("Active from hook: ", activeAgreementId)
    console.log("****** AGREEMENT ID FROM ROUTER*******", agreementId)
    const { error: agreementError} = useContext(AgreementContext)

    const isMobile = useMediaQuery("(max-width:600px")
  
    const isBeta = localStorage.getItem("isBeta") === "true"
    const menuItems = [
        {name: "Oversikt", path: `${url}`},
        {name: "Selg faktura", path: `${url}/selgfaktura`},
        {name: "Rapporter", path: `${url}/rapporter`}
        //{name: "Fakturaoversikt", path: `${url}/behandlingsoversikt`}
    ]

    return ( agreementError ? <Alert severity="error">Kunne ikke hente dine avtaler. Dette kan skyldes en midlertidig feil i våre systemer, eller at du ennå ikke er kunde hos oss.</Alert> 
        : <>
              <Sb1Header agreement={agreementId} menuItems={menuItems}>

              <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={agreementId}
                      label="Agreement"
                      sx={{height: "40px"}}
                    >
                      { agreements?.map(agreement => <SelectMenuItem key={agreement.id} value={agreement.id}><Link to={`/avtale/${agreement.id}`}>{agreement.name}</Link></SelectMenuItem>) }
                    </Select>
                    </Sb1Header>
                  <Switch>
                      <ProtectedRoute path={`${url}`} exact>
                          <HomePage  agreementId={agreementId} />
                       </ProtectedRoute>
                      <Route path={`${url}/behandlingsoversikt`}>
                            { isBeta ? <OrderList /> : <div />}
                      </Route>
                      <Route path={`${url}/selgfaktura`}>
                        <SellInvoicePage />
                      </Route>
                      <Route path={`${url}/rapporter`}>
                        <ReportsPage agreementId={agreementId} vendorsApi={vendorsApi} />
                      </Route>
                      {/*<Route path={`${url}/ordre`}>
                            { isBeta ? <OrderList /> : <div />}
                      </Route>
                        */}
                  </Switch>
              { /*isMobile && <BottomNavigation
                  showLabels
                  sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
              >
                  <BottomNavigationAction label="Oversikt" icon={<Link to={`${url}`}><HomeIcon /></Link>} />
                  <BottomNavigationAction label="Selg faktura " icon={<Link to={`${url}/selgfaktura`}><PointOfSaleIcon /></Link>} />
                  <BottomNavigationAction label="Bevegelser" icon={<Link to={`${url}/behandlingsoversikt`}><AccountBalanceIcon /></Link>} />
              </BottomNavigation>
                    */}
        </>
    )
}